import { computed } from 'vue';
import { store } from '@/store';
import { useConditions } from '@shared/composables/useConditions';
import { ConditionPickerOption } from '@/shared/components/conditions/models/conditions';

export function useAudienceConditions() {
  // Initialize base conditions with all contact attributes from store
  const base = useConditions(store.getters.allContactAttributes);

  // Override visibleConditions to filter out archived attributes
  const visibleConditions = computed(() => {
    return base.conditions.value.filter((option: ConditionPickerOption) => {
      const attributeId = option.id.substring(option.id.lastIndexOf('.') + 1);
      return !store.getters.isAttributeArchived(attributeId);
    });
  });

  return {
    ...base, // Spread all base functionality
    visibleConditions, // Override with our specific implementation
  };
}
